import { TenantEntity } from '../TenantEntity'

export class FbaQuotationLabel extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FbaQuotationLabel'
  }

  get labelName() {
    return this._data.labelName
  }
  set labelName(labelName) {
    this._data.labelName = labelName
  }
  get backgroundColor() {
    return this._data.backgroundColor
  }
  set backgroundColor(backgroundColor) {
    this._data.backgroundColor = backgroundColor
  }
  get textColor() {
    return this._data.textColor
  }
  set textColor(textColor) {
    this._data.textColor = textColor
  }
  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid
  }
}
